import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './static/css/navbar.css'
import './static/css/index.css'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementsByClassName('root')[0]
);
